// The conversation with Ogma beside any page (the Ask bar opens it with the question typed there). The same
// conversation as a full page is Ask Ogma (screens/AskOgma.tsx); both are components/chat/Chat.tsx.
import { useEffect } from "react";
import { Chat } from "./chat/Chat";

/** `asked`: a question from the Ask bar (components/kit/AskBar.tsx) to send as soon as the drawer is open; each id is sent once. */
export function ChatDrawer({ open, onClose, asked = null }: { open: boolean; onClose: () => void; asked?: { id: number; text: string } | null }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);
  if (!open) return null;
  return (
    <aside className="chat" role="dialog" aria-modal="false" aria-labelledby="chat-title">
      <div className="chat-head">
        <h2 id="chat-title">Ask the assistant</h2>
        <button type="button" className="btn-icon" aria-label="Close the assistant" onClick={onClose}>
          ×
        </button>
      </div>
      <Chat active={open} asked={asked} inputId="chat-input" />
    </aside>
  );
}
